<template>
    <div class="trx-body">
        <div class="header-title">Request History</div>

        <b-card no-body id="content">
            <b-tabs card>
                <b-tab active title-link-class="tab">
                    <template v-slot:title>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22.998" height="23" viewBox="0 0 33.998 34">
                        <g id="Group-18" transform="translate(-727.35 -294.35)">
                            <path id="Path_103" data-name="Path 103" d="M756.4,328.35H732.3a4.955,4.955,0,0,1-4.949-4.949V299.3a4.955,4.955,0,0,1,4.949-4.949h17.675a4.956,4.956,0,0,1,4.947,4.949v24.1a1.481,1.481,0,0,0,1.479,1.479,1.735,1.735,0,1,1,0,3.471Zm-24.1-30.53a1.481,1.481,0,0,0-1.479,1.479v24.1a1.481,1.481,0,0,0,1.479,1.479h19.377a4.934,4.934,0,0,1-.226-1.479V299.3a1.481,1.481,0,0,0-1.478-1.479Z" fill="#707070"/>
                            <path id="Path_104" data-name="Path 104" d="M1063.55,553.6a4.955,4.955,0,0,1-4.95-4.949V539.01a1.735,1.735,0,0,1,1.735-1.735h3.214a4.956,4.956,0,0,1,4.948,4.949v6.426A4.956,4.956,0,0,1,1063.55,553.6Zm-1.48-12.855v7.905a1.478,1.478,0,1,0,2.956,0v-6.426a1.481,1.481,0,0,0-1.478-1.479Z" transform="translate(-307.149 -225.25)" fill="#707070"/>
                            <path id="Path_105" data-name="Path 105" d="M828.657,507.621H817.41a1.735,1.735,0,0,1,0-3.471h11.247a1.735,1.735,0,0,1,0,3.471Z" transform="translate(-81.899 -194.535)" fill="#707070"/>
                            <path id="Path_106" data-name="Path 106" d="M823.837,595.945H817.41a1.735,1.735,0,0,1,0-3.47h6.426a1.735,1.735,0,0,1,0,3.47Z" transform="translate(-81.899 -276.434)" fill="#707070"/>
                            <path id="Path_107" data-name="Path 107" d="M828.657,419.3H817.41a1.735,1.735,0,0,1,0-3.47h11.247a1.735,1.735,0,0,1,0,3.47Z" transform="translate(-81.899 -112.638)" fill="#707070" />
                        </g>
                        </svg>

                        <span class="tab-title">History</span>
                    </template>
                    

                    <div class="d-flex justify-content-center align-items-center h-100 mt-4 spinning" v-if="isLoading">
                        <b-spinner variant="success" label="Spinning"></b-spinner>
                    </div>

                    <div class="trx-table" v-if="switch_tab === 1 && !isLoading">
                        <div class="col-lg-3 col-6">
                            <button @click="updateTransaction" class="btn activate-btn w-100 p-1">{{refreshStatus}}</button>
                        </div>
                        <b-table
                            tbody-tr-class="rowClass"
                            :items="request_deposit_histories"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :fields="requestHistoryFields"
                            :total-rows="totalRows"
                            show-empty
                            small
                            responsive
                            detailed
                            empty-filtered-text="No Data"
                            class="trx-table"
                            id="request-history-table"
                            @row-clicked="handleRowClicked"
                        >
                            <!-- start table header -->
                            <template v-slot:head(deposit_id)>
                            <div class="table-header-content">
                                <div>DEPOSIT ID</div>
                                <!-- <div>
                                <select
                                    v-model="status_sort_selected"
                                    id="coinList"
                                    class="tx-dropdown"
                                >
                                    <option v-for="sort in coin_sort" :key="sort.sortID">
                                    {{ sort.sortName }}
                                    </option>
                                </select>
                                </div> -->
                            </div>
                            </template>

                            <!-- <template v-slot:head(receiving_address)>
                            <div class="table-header-content">
                                <div>RECEIVING ADDRESS</div>
                                <div>
                                </div>
                            </div>
                            </template> -->

                            <template v-slot:head(token)>
                            <div class="table-header-content">
                                <div>COIN</div>
                                <div>
                                    <!-- <select v-model="coinSort_selected" id="coinSortList" class="tx-dropdown">
                                        <option v-for="sort in coin_sort" :key="sort.sortID">
                                        {{ sort.sortName }}
                                        </option>
                                    </select> -->
                                    <select v-model="coinSelected" @change="changeSelectedCoin" id="coinSortList" class="tx-dropdown">
                                        <option v-for="coinOption in coinOptions" :value="coinOption" :key="coinOption.id">
                                        {{ coinOption.api_symbol }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            </template>

                            <template v-slot:head(amount)>
                            <div class="table-header-content">
                                <div>AMOUNT</div>
                                <!-- <div>
                                <input type="text" class="txID-readonly" placeholder="Total: 0.00000" readonly="readonly"/>
                                </div> -->
                            </div>
                            </template>

                            <template v-slot:head(start_time)>
                            <div class="table-header-content">
                                <div>START TIME</div>
                                <!-- <div>
                                <input type="text" class="txID-readonly" placeholder="Total: 0.00000" readonly="readonly"/>
                                </div> -->
                            </div>
                            </template>

                            <template v-slot:head(end_time)>
                            <div class="table-header-content">
                                <div>END TIME</div>
                                <!-- <div>
                                <input type="text" class="txID-readonly" placeholder="Total: 0.00000" readonly="readonly"/>
                                </div> -->
                            </div>
                            </template>

                            <template v-slot:head(status)>
                            <div class="table-header-content">
                                <div>STATUS</div>
                                <div>
                                    <select
                                        v-model="statusSelected"
                                        id="coinList"
                                        class="tx-dropdown"
                                    >
                                        <option v-for="status in allStatus" :value="status.value" :key="`status${status.value}`">
                                        {{ status.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            </template>

                            <template v-slot:head(links)>
                            <div class="table-header-content">
                                <div>LINKS</div>
                                <!-- <div>
                                <input type="text" class="txID-readonly" placeholder="Total: 0.00000" readonly="readonly"/>
                                </div> -->
                            </div>
                            </template>
                            <!-- end table header -->

                            <!-- start table body -->
                            <template #cell(hash)="row">
                            <div class="trxID-td" v-if="row.item.hash == null || row.item.hash == ''">—</div>

                            <!-- <div class="d-flex flex-row justify-content-between" v-else> -->
                                <div class="trxID-td" v-else>
                                {{ row.item.deposit_id == null || row.item.deposit_id == '' ? '—' : txIDFormatter(row.item.deposit_id) }}
                                </div>
                                <!-- <div class="tooltip__layout" v-if="row.item.hash != null || row.item.hash != ''">
                                <button class="icon-btn pl-2" @click="copyToClip(row.item.hash, `hash` + row.item.id)">
                                    <inline-svg
                                    :src="require('../assets/icon/copy.svg')"
                                    width="18"
                                    aria-label="copy"
                                    ></inline-svg>
                                    <span class="tooltip__content" :id="'hash' + row.item.id">Copied!</span>
                                </button>
                                </div> -->
                            <!-- </div> -->
                            </template>
                            <!-- <template #cell(receiving_address)="row">
                            {{ row.item.to.address }}
                            </template> -->
                            <template #cell(token)="row">
                                {{ row.item.token.api_symbol }}
                            </template>
                            <template #cell(amount)="row">
                                {{addCommas(row.item.amount)}}
                            <!-- {{ addCommas(formatNumber(row.item.amount, row.item.token.decimal).toFixed(row.item.token.volume_decimal)) }} -->
                            </template>
                            <template #cell(start_time)="row">
                                {{ timestampFormatter(row.item.start) }}
                            </template>
                            <template #cell(end_time)="row">
                                {{ timestampFormatter(row.item.end) }}
                            <!-- {{ addCommas(formatNumber(row.item.service_fee, row.item.token.decimal).toFixed(row.item.token.volume_decimal)) }} -->
                            <!-- {{ row.item.service_fee}} -->
                            </template>
                            <template #cell(status)="row">
                            <span
                                class="table_status" 
                                :style="
                                    (row.item.status == 'success') ? 'color: var(--primary)' :
                                    (row.item.status == 'fail') ? 'color: var(--danger)' :
                                    'color: var(--info)'
                                "
                            >
                                {{ row.item.status }}
                            </span>
                            </template>
                            <template #cell(links)="row">
                                <div class="d-flex flex-row w-100">
                                    <div class="tooltip__layout">
                                        <b-icon-box-arrow-up-right type="button" class="mx-2" @click="goToRequestDepositDetails(row.item.deposit_id)"></b-icon-box-arrow-up-right>
                                        <button class="icon-btn pl-2" @click="copyDepositLink(row.item.deposit_id, `link` + row.item.id)">
                                            <inline-svg
                                                :src="require('../assets/icon/copy.svg')"
                                                width="18"
                                                aria-label="copy"
                                            ></inline-svg>
                                            <span class="tooltip__content" :id="'link' + row.item.id">Copied!</span>
                                        </button>
                                    </div>
                                </div>
                            <!-- {{ addCommas(formatNumber(row.item.service_fee, row.item.token.decimal).toFixed(row.item.token.volume_decimal)) }} -->
                            <!-- {{ row.item.service_fee}} -->
                            </template>
                            <template #empty="scope">
                                <p class="text-center">{{ (scope.emptyText = "No Data") }}</p>
                            </template>
                            <!-- end table body -->

                            <!-- start expanded body -->
                            <template slot="row-details" slot-scope="row">
                            <div class="d-flex flex-column w-100">
                                <div class="d-flex flex-row w-100">
                                    <div class="expand-left">TX ID</div>

                                    <div class="expand-right">
                                        <div class="mr-3 trxID-td">{{ row.item.hash == null || row.item.hash == '' ? "—" : row.item.hash }}</div>

                                        <div class="tooltip__layout" v-if="!(row.item.hash == null || row.item.hash == '')">
                                            <b-icon-box-arrow-up-right class="mx-2" type="button" @click.stop.prevent="toExplorer(coinSelected.network.symbol.toLowerCase(), row.item.hash)"></b-icon-box-arrow-up-right>
                                            <button class="icon-btn pl-2" @click="copyToClip(row.item.hash, `hash` + row.item.id)">
                                                <inline-svg
                                                    :src="require('../assets/icon/copy.svg')"
                                                    width="18"
                                                    aria-label="copy"
                                                ></inline-svg>
                                                <span class="tooltip__content" :id="'hash' + row.item.id">Copied!</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex flex-row w-100">
                                    <div class="expand-left">To Address</div>

                                    <div class="expand-right">
                                        <div class="mr-3">{{ row.item.to == null || row.item.to == '' ? "—" : row.item.to }}</div>

                                        <div class="tooltip__layout" v-if="!(row.item.to == null || row.item.to == '')">
                                        <button class="icon-btn pl-2" @click="copyToClip(row.item.to, `to_address` + row.item.id)">
                                            <inline-svg
                                                :src="require('../assets/icon/copy.svg')"
                                                width="18"
                                                aria-label="copy"
                                            ></inline-svg>
                                            <span class="tooltip__content" :id="'to_address' + row.item.id">Copied!</span>
                                        </button>
                                        </div>
                                    </div>
                                </div>          
                            </div>
                            </template>
                            <!-- end expanded body -->
                        </b-table>

                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="10"
                            aria-controls="request-history-table"
                            align="center"
                        ></b-pagination>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>
<script>
import api from '../helper/api.js';
import explorer from '../helper/explorer.js';
import moment from "moment";
import InlineSvg from "vue-inline-svg";

export default {
    name:"RequestHistory",
    components: {
        InlineSvg,
        // VueQr
    }, 
    data(){
        return{
            switch_tab: 1,
            request_deposit_histories:null,
            requestHistoryFields: [
                { key: "deposit_id", label: "DEPOSIT ID" },
                // { key: "receiving_address", label: "REECEIVING ADDRESS" },
                { key: "token", label: "COIN"},
                { key: "amount", label: "AMOUNT" },
                { key: "start_time", label: "START TIME" },
                { key: "end_time", label: "END TIME" },
                { key: "status", label: "STATUS" },
                { key: "links", label: "LINKS" }
            ],
            coin_sort: [
                { sortID: 0, sortName: 'All' },
                { sortID: 1, sortName: 'Alphabet A-Z' },
                { sortID: 2, sortName: 'Alphabet Z-A' },
            ],
            dateTime_sort: [
                { sortID: 0, sortName: 'All' },
                { sortID: 1, sortName: 'Past 7 Days' },
                { sortID: 2, sortName: 'Past 30 Days' },
                { sortID: 3, sortName: 'Past 90 Days' },
            ],
            status_sort: [
                { sortID: 0, sortName: 'All' },
                { sortID: 1, sortName: 'Pending' },
                { sortID: 2, sortName: 'Failed' },
            ],
            coinSort_selected: 'All',
            dateTime_sort_selected: 'All',
            status_sort_selected: 'All',
            currentPage: 1,
            totalRows: 0,
            perPage: 10,
            isLoading:false,
            opened: [],
            allOpenRows: [],
            coinSelected:[],
            coinOptions:[],
            allStatus:[
                {value:null, text:"All"},
                {value:"pending", text:"Pending"},
                {value:"deposited", text:"Deposited"},
                {value:"unused", text:"Unused"},
                {value:"unmatched", text:"Unmatched"}
            ],
            statusSelected:null,
            refreshStatus:"Update"
        }
    },

    watch:{
        currentPage: {
            async handler() {
                this.isLoading = true
                await this.fetchRequestDeposits();
            },
            deep: true,
        },

        perWithdraw: {
            async handler() {
                this.isLoading = true
                await this.fetchRequestDeposits();
            },
            deep: true,
        },

        statusSelected(){
            this.isLoading = true;
            this.fetchRequestDeposits();
        }
    },

    async mounted() {
        this.isLoading = true;
        await this.fetchCoins();
        await this.fetchRequestDeposits();
        // this.isLoading = false;
    },

    methods: {

        async copyToClip(address, id) {
            await this.$copyText(address).then(function () {
                var x = document.getElementById(id);
                x.classList.add("show");
                setTimeout(function () {
                    x.classList.remove("show");
                }, 2000);
            })
        },

        async copyDepositLink(depositId, id) {
            const frontendURL = process.env.VUE_APP_FRONTEND_URL 
            const network = this.coinSelected.network.symbol.toLowerCase()
            const platformId = localStorage.getItem('platform_id')
            const depsoitLink = frontendURL + '/deposit/' + network + '/' + platformId + '/' + depositId
            this.copyToClip(depsoitLink, id)
        },

        async fetchCoins(){
            try{
                const response = await api.apiCall('core','GET','/tokens/get-all');
                this.coinOptions = response.message;        
                // this.coinSelected = this.coinOptions.filter((item)=>item.api_symbol == 'TRX')[0];
                this.coinSelected = this.coinOptions[0];
            }catch(error){
                console.error(error);
            }
        }, 

        async fetchRequestDeposits(){
            try{
                const response = await api.apiCall(this.coinSelected.network.symbol.toLowerCase(),'GET',`/deposit-request/get-all`,{
                    order:'DESC',
                    page:this.currentPage,
                    take:10,
                    status:this.statusSelected,
                    api_symbol:this.coinSelected.api_symbol,
                });
                this.request_deposit_histories = response.message.data;
                this.totalRows = response.message.meta.itemCount;
                this.rows = response.message.meta.itemCount;
                this.currentPage = response.message.meta.page
                this.perPage = this.request_deposit_histories - (10* this.currentPage)
                this.isLoading = false;
            }catch(error){
                console.error(error);
            }
        },

        async updateTransaction(){
            this.refreshStatus = 'Updating...';
            await this.fetchRequestDeposits();
            this.refreshStatus = 'Update'
        },  

        goToRequestDepositDetails(id){
            const routeData = this.$router.resolve(
                {name:'DepositDetail', params:{network:this.coinSelected.network.symbol.toLowerCase(), platformId:localStorage.getItem('platform_id'), id:id}}
            );
            window.open(routeData.href, '_blank');
        },

        addCommas (nStr) {
            nStr += ''
            var x = nStr.split('.')
            var x1 = x[0]
            var x2 = x.length > 1 ? '.' + x[1] : ''
            var rgx = /(\d+)(\d{3})/
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2')
            }
            return x1 + x2
        },

        timestampFormatter(value) {
            if (value) {
                // value = new Date(value/1000);
                return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        handleRowClicked(item) {
            this.allOpenRows.map((ele) => {
                if (ele.id !== item.id && ele._showDetails) {
                this.$set(ele, "_showDetails", !ele._showDetails);
                }
            });
            this.allOpenRows = [];
            this.$set(item, "_showDetails", !item._showDetails);
            this.allOpenRows.push(item);
        },

        changeSelectedCoin(){
            this.fetchRequestDeposits();
            this.isLoading = true;
        },

        toExplorer(network,hash){
            let url = explorer.explorerLink(network, 'tx', hash)
            window.open(url, '_blank').focus();
        }
    },
}
</script>

<style>
@import '../css/styles.css';

.trx-body {
    height: 100%;
    overflow: scroll;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.trx-body::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.trx-body {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.rowClass:hover {
    cursor: pointer;
}

.b-table-details:hover {
    cursor: auto;
}
.balance-body {
    margin: 0% 17%;
    height: 100%;
    overflow: scroll;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.balance-body::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.balance-body {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.top-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* margin: 0% 10%; */
    margin-top: 4rem;
}

.table-responsive {
    display: inline-table;
}

.trx-table {
    font-size: 13px;
    text-align: center;
    margin-top: 2rem;
}

.trx-table th, .trx-table td {
    font-size: 16px;
    border: 1px !important;
}

.trx-table table {
    border-collapse: separate; 
    border-spacing:  0 8px;
}

.trx-table td {
    border-bottom: none;
    padding: 7px 20px;
}

.rowClass {
    background-color: var(--light);
}

.b-table-has-details {
    background-color: aliceblue !important;
}

.rowClass:hover {
    cursor: pointer;
    background-color: aliceblue ;
}

.b-table-details:hover {
    cursor: auto;
    background-color: white ;
}

.expand-left {
    width: 15%;
    padding: 7px 0px;
    text-align: left;
}

.expand-right {
    width: 85%;
    text-align: left;
    padding-left: 4rem;
    display: flex;
    flex-direction: row;
    align-items: center;
}


select {
    text-align-last: center;
}

.bal-button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 2rem;
    margin-bottom: 1rem;
}

.total-balance {
    color: var(--info);
    font-size: 38px;
} 

.balance-token-text1 {
    font-size: 18px;
}

.balance-token-text2 {
    font-size: 13px;
}

.bal-btn {
    background-color: transparent;
    /* min-width: 100px; */
    width: 30%;
    border-radius: 30px;
    border: 2px solid var(--primary);
    color: var(--primary);
    font-weight: bold;
    cursor: pointer;
    /* margin-left: 2rem; */
    display: flex;
    align-items: center;
    justify-content: center;
    height: 55px;
}

.bal-btn:hover, .bal-btn:active, .bal-btn:focus {
    color: var(--primary) !important;
    fill: var(--primary) !important;
    border: 2px solid var(--primary) !important;
    background-color: var(--primary-10) !important;
    /* box-shadow: rgba(255, 255, 255, 0.2) 0px 2px 8px 0px; */
}

.bal-btn #swap {
    fill: var(--primary);  
    padding-left: 0.8rem;
}

.bal-btn div {
    padding-left: 1rem;
}

.bal-btn img {
    width: 30px;
}

/* Child Address Table */
.add-child-btn {
    background-color: var(--primary);
    /* border: none; */
    border-radius: 20px;
    padding: 0px 20px 0 40px;
    /* width: 100px; */
    color: var(--light);
    border: 1px solid var(--primary);
    height: 25px;
    /* padding-left: 45px; */
    position: relative;
    min-width: fit-content;
    font-weight: bold;
    display: flex;
    align-items: center;
}

.add-child-btn:before {
    content: "";
    display: block;
    background-color: var(--primary);
    border-radius: 100%;
    width: 35px;
    height: 35px;
    left: -1px;
    box-shadow: 0 3px 10px rgb(0 0 0 / 31%);
    bottom: -6px;
    position: absolute;
}

#plus-icon {
    position: absolute;
    left: 6px;
    top: -1px;
    color: white;
}

.add-child-btn:hover, .add-child-btn:focus, .add-child-btn:hover text {
    color: var(--primary);
    background-color: var(--light);
    fill: var(--light);
    border: 1px solid var(--primary);
}

.search-input {
    display: flex;
    flex-direction: row;
    position: relative;
    align-items: center;
}

.search-input input {
    border-radius: 20px;
    padding: 0px 15px;
    height: 25px;
}

.search-input:after {
    content: "";
    display: block;
    background-color: white;
    border-radius: 100%;
    width: 35px;
    height: 35px;
    box-shadow: 0 3px 10px rgb(0 0 0 / 31%);
    bottom: -6px;
    right: 0;
    position: absolute;
}

.search-icon {
    position: absolute;
    z-index: 2;
    right: 7px;
}

#child-add-table tbody::before {
    content: '';
    display: block;
    height: 10px;
}

#child-add-table th {
    font-size: 14px;
    text-align: center;
}

#child-add-table tr {
    background-color: var(--light);
    color: black;
    text-align: center;
}

#child-add-table td {
    vertical-align: middle;
}

#child-add-table tr:first-child td:first-child { border-radius: 30px 0px 0px 30px; }
#child-add-table tr:first-child td:last-child { border-radius: 0px 30px 30px 0px; }

.child-table-th {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.table-header-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.txID-readonly {
    background-color: rgba(0, 0, 0, 0.1);
    border: none;
    border-radius: 15px;
    min-width: 100px;
    width: 120px;
    color: black;
}

.tx-dropdown {
    border: none;
    color: black;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    height: 23px;
}
/* #add-child-form input {
    background-color: var(--info-10);
    border: none;
    color: var(--info);
    text-align: center;
    border-radius: 30px;
    width: 100%;
} */

.icon-btn {
    padding: 0px;
}

.balance-token {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 35%;
}

.balance-withdrawal {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.deposit-balance {
    display: flex;
    flex-direction: row;
    width: 65%;
    justify-content: space-between;
}

.deposit-balance>div {
    width: 45%;
}

.balance-title {
    font-size: 1rem;
    /* font-weight: bold; */
    color: var(--primary);
    text-align: center;
}

.balance-content {
    font-size: 2rem;
    text-align: center;
    color: var(--info);
}

/* Send Modal */
fieldset {
    color: #555;
    font-family: sans-serif;
    border: none;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

fieldset::after {
    content: "___  ___  ___  ___  ___  ___";
    display: block;
    position: absolute;
    top: 35px;
    white-space: pre;
    color: white;
}

input#tradingPin {
    position: relative;
    font-size: 16px;
    z-index: 2;
    border: none;
    background: transparent;
    width: 300px;
    text-indent: 27px;
    letter-spacing: 25.6px;
    font-family: Courier;
    margin-left: 55px;
    text-align: left;
}

input#tradingPin:focus {
    outline: none;
}

/* Receive Modal */
#receive-content {
    background: transparent;
    border: none;
}

#receive-content .card-header {
    border-bottom: 1px solid white;
    border-top: 2px solid white;
    background: transparent;
    padding: 0rem 0rem 0.75rem 0rem;
    overflow: hidden;
    overflow-x: scroll;
}

#receive-content .nav {
    flex-wrap: nowrap;
}

#receive-content .nav-item {
    padding-top: 2px;
    margin-left: 5px;
}

#receive-content .nav-item a{
    width: 150px;
    text-align: center;
    border: none;
    color: #bbbbbb;
}

#receive-content .nav-item a:hover {
    border-bottom: 2px solid var(--primary);
    color: var(--primary);
}

#receive-content .nav-item .active {
    border-bottom: 2px solid var(--primary);
    color: var(--primary);
    background: transparent;
}

.modal-wallet-address {
    color: #707070;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-bottom: 2rem;
}

.withdraw {
    color: var(--danger);
}

.table-responsive {
    display: inline-table;
}

@media only screen and (max-width:768px) {
    .balance-token {
        width: 100%;
        justify-content: center;
        margin-bottom: 1.5rem;
    }

    .balance-withdrawal {
        flex-direction: column;
    }

    .deposit-balance {
        width: 100%;
    }

    .table-responsive {
        display: block;
    }

    .balance-body {
        margin: 5%;
    }

    .total-balance {
        font-size: 30px;
    }

    .search-input {
        margin-left: 1rem;
    }

    .bal-button {
        flex-direction: column;
    }

    .bal-btn {
        width: 100%;
        margin-bottom: 1rem;
    }
}
</style>